import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useProductPageContext } from '../productPageContext'

import { ProductDescriptionCautionsDisclaimer } from './ProductDescriptionCautions'
import { ProductDescriptionLegalName } from './ProductDescriptionLegalName'
import { ProductDescriptionManufacturerDetails } from './ProductDescriptionManufacturerDetails'
import { ProductDescriptionOldLayout } from './ProductDescriptionOldLayout'
import { ProductDescriptionPromotions } from './ProductDescriptionPromotions'
import { ProductDescriptionResponsiblePersonEu } from './ProductDescriptionResponsiblePersonEu'
import { ProductDescriptionTopDescriptions } from './ProductDescriptionTopDescriptions'
import { ProductDescriptionWithMultipleAccordions } from './ProductDescriptionWithMultipleAcordions'
import { useProductDescriptionSections } from './useProductDescriptionSections'

export const ProductDescription: FC<{ className: string }> = ({
  className,
}) => {
  const { product } = useProductPageContext()
  const { hasIfapSections } = useProductDescriptionSections()

  return (
    <div className={className} data-qa-id="product-description">
      <div className="scroll-mt-4" id="pflichtangabe" />
      <h2 className="mb-5 text-2xl font-medium">
        <FormattedMessage id="productAdditonalInfos.headline" />
      </h2>
      <ProductDescriptionCautionsDisclaimer />
      <ProductDescriptionTopDescriptions product={product} />
      {product.legal_name ? (
        <ProductDescriptionLegalName legalName={product.legal_name} />
      ) : null}
      <ProductDescriptionPromotions />
      {hasIfapSections || product.has_split_attributes ? (
        <ProductDescriptionWithMultipleAccordions />
      ) : null}
      {!product.has_split_attributes && !hasIfapSections && (
        <ProductDescriptionOldLayout />
      )}
      {product.manufacturer_details ? (
        <ProductDescriptionManufacturerDetails
          manufacturerDetails={product.manufacturer_details}
        />
      ) : null}
      {product.responsible_person_eu ? (
        <ProductDescriptionResponsiblePersonEu
          responsiblePersonEU={product.responsible_person_eu}
        />
      ) : null}
    </div>
  )
}
